import './Badge.scss';
import cn from 'classnames';
import { ReactNode } from 'react';
import {
  Appearance,
  AppearanceType,
  Background,
  BackgroundType,
  Design,
  DesignType,
  IntentType,
  Size,
  SizeType
} from '../designConstants';

type BadgeDesignType = DesignType | IntentType;

interface BadgeProps {
  size?: SizeType;
  design?: BadgeDesignType;
  background?: BackgroundType;
  appearance?: AppearanceType;
  // Any node. Icons and images are sized to the badge icon size; images are clipped to a circle.
  leadingElement?: ReactNode;
  trailingElement?: ReactNode;
  className?: string;
  children?: ReactNode;
}

export const Badge = ({
  size = Size.MD,
  design = Design.BRAND,
  background = Background.LIGHT,
  appearance = Appearance.FILLED,
  leadingElement,
  trailingElement,
  className,
  children
}: BadgeProps) => (
  <span className={cn('bpm-badge', size, design, background, appearance, className)}>
    {leadingElement && <span className='bpm-badge-element'>{leadingElement}</span>}
    <span className='bpm-badge-label'>{children}</span>
    {trailingElement && <span className='bpm-badge-element'>{trailingElement}</span>}
  </span>
);
